export default "__VITE_ASSET__16e0fda0__"